import { Typography, Button } from '@frontend/design_system'
import styles from './styles.module.scss'
import { REVIEW } from 'texts/notifications'
import { useLocation, useNavigate } from 'react-router-dom'
import { NotificationType } from 'api/notifications/types'
import { NOTIFICATION_PATH_MAP } from './utils'
import { setAccountStatus } from 'redux/login/slice'
import { useDispatch } from 'react-redux'

interface NotificationProps {
  notificationId: number
  onToggle: () => void
  title: string
  message: string
  companyName: string
  id: number
  companyId: number
  notificationType: NotificationType
}

export const Notification = ({
  onToggle,
  title,
  message,
  companyName,
  companyId,
  notificationType,
}: NotificationProps) => {
  const navigate = useNavigate()
  const location = useLocation()

  const dispatch = useDispatch()
  const onReview = async () => {
    const path = NOTIFICATION_PATH_MAP[notificationType](companyId)
    if (location.pathname !== path) {
      dispatch(setAccountStatus('Approved'))
    }
    navigate(path, {
      state: { companyId },
    })
    onToggle()
  }

  return (
    <div className={styles.notification}>
      <Typography
        name="caption1WBold"
        className={styles.supplier}
        color="blue700"
      >
        {companyName}
      </Typography>
      <Typography name="body1WBold" className={styles.status}>
        {title}
      </Typography>
      <Typography name="body2WMedium" className={styles.message}>
        {message}
      </Typography>
      <Button
        onClick={onReview}
        variant="secondary-border"
        label={REVIEW}
        typographyName="body1WMedium"
        size="large"
      />
    </div>
  )
}
